import api from '@/lib/api';

function loadCheckout() {
  if (window.Razorpay) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = 'https://checkout.razorpay.com/v1/checkout.js';
    s.onload = resolve;
    s.onerror = () => reject(new Error("Couldn't load the payment window. Check your internet."));
    document.body.appendChild(s);
  });
}

/** Opens Razorpay Checkout for a top-up. Resolves with the new balance (paise) once the
 * server has verified the payment; resolves null if the customer closed the window. */
export async function topUp(amountPaise) {
  await loadCheckout();
  const { data: order } = await api.post('/api/wallet/topup', { amount_paise: amountPaise });
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: order.key_id,
      order_id: order.order_id,
      amount: order.amount,
      currency: 'INR',
      name: 'Rayogent',
      description: 'Add money to your ad balance',
      prefill: order.prefill,
      theme: { color: '#FF7A1A' },
      handler: async (resp) => {
        try {
          const { data } = await api.post('/api/wallet/verify-payment', resp);
          resolve(data.balance_paise);
        } catch (err) {
          reject(new Error(err.response?.data?.detail || 'We could not confirm the payment yet. Your balance will update shortly.'));
        }
      },
      modal: { ondismiss: () => resolve(null) },
    });
    rzp.on('payment.failed', (r) => reject(new Error(r.error?.description || "The payment didn't go through.")));
    rzp.open();
  });
}
